'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import Icon from '@/ui/components/Icon';
import { useManual } from '@/ui/components/Manual/ManualContextProvider';
import Comments from '@/ui/components/Manual/Sidebar/Comments';
import Contents from '@/ui/components/Manual/Sidebar/Contents';
import {
  ManualSidebar as StyledSidebar,
  ManualSidebarClose,
  ManualContents,
  ManualComments,
  ManualCommentsHeadline,
  ManualCommentsWrapper,
  ManualCommentsHide,
} from '@/ui/components/Manual/Sidebar/index.styled';

interface ManualSidebarProps {
  showContent: boolean;
  isLoading?: boolean;
}

export function ManualSidebar({ showContent, isLoading }: ManualSidebarProps) {
  const t = useTranslations();
  const { activeStep, sidebar, updateSidebar, steps, guide, categories, siblings, initialComments } = useManual();

  const isVisible = sidebar === 'comments' || (showContent && sidebar === 'contents');

  if (isLoading) {
    return (
      <StyledSidebar $isVisible={isVisible}>
        <div>
          <div className="pulse" style={{ height: '18px', marginBottom: '16px' }} />
          <div className="pulse" style={{ height: '18px', marginBottom: '16px', marginTop: '16px' }} />
          <div className="pulse" style={{ height: '18px', marginBottom: '16px', marginTop: '16px' }} />
          <div className="pulse" style={{ height: '18px', marginBottom: '16px', marginTop: '16px' }} />
          <div className="pulse" style={{ height: '18px', marginBottom: '16px', marginTop: '16px' }} />
          <div className="pulse" style={{ height: '18px', marginTop: '16px' }} />
        </div>
      </StyledSidebar>
    );
  }

  return (
    <StyledSidebar $isVisible={isVisible} $sidebarIsComments={sidebar === 'comments'}>
      <ManualSidebarClose onClick={() => updateSidebar(null)}>
        <Icon name="xmark" />
      </ManualSidebarClose>

      {steps?.length > 0 && (
        <ManualContents $isVisible={sidebar === 'contents'}>
          <h3>{t('manual-menu-contents')}</h3>
          <Contents
            activeStep={activeStep}
            guide={guide}
            categories={categories}
            siblings={siblings}
            steps={steps}
            updateSidebar={updateSidebar}
            sidebar={sidebar}
          />
        </ManualContents>
      )}

      <ManualComments $isVisible={sidebar === 'comments'}>
        <ManualCommentsHeadline>
          <h3>{t('manual-menu-comments')}</h3>
          <ManualCommentsHide onClick={() => updateSidebar(null)}>
            <Icon name="xmark" />
          </ManualCommentsHide>
        </ManualCommentsHeadline>

        <ManualCommentsWrapper>
          <Comments
            postId={steps[activeStep]?.id || guide?.id}
            visible={sidebar === 'comments'}
            initialComments={initialComments}
          />
        </ManualCommentsWrapper>
      </ManualComments>
    </StyledSidebar>
  );
}
